import Cookies from 'js-cookie'

const TokenKey = 'x-auth-token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,24*60*60*1000)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js